module.exports = __webpack_public_path__ + "static/lights14-375b8196a601c5d69d044c61f7c8e7cc.jpg";